import React from 'react'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import MemberImages from 'srcReact/components/common2/MemberImages'
import Badge from 'srcReact/components/common2/Badge'
import { formatLastUpdateDate } from 'srcReact/helpers/datetimeHelper'
import { redirectToPage } from 'srcReact/helpers/history'
import { useSelector } from 'react-redux'
import Icon from 'srcReact/components/icons/Icon'
import MemberNames from 'srcReact/components/common2/MemberNames'

function ConversationsList({ conversation, closeMenu }) {
  const { t } = useTranslation()
  const {
    common: { isMobile, isNative, isTablet }
  } = useSelector((state) => state)

  const conversationName = (
    <MemberNames
      id={conversation.conversation.id}
      members={conversation.active_users.filter((u) => !u.is_logged_user)}
      conversationName={conversation.conversation.user_conversation_name}
      isMobile={isMobile || isNative}
      isTablet={isTablet}
    />
  )
  const badge = conversation.conversation.userUnreadMessageCount
  const conversationId = conversation.conversation.id
  let lastUpdatedDate = ''
  let lastMessage = ''
  let recentMessage =
    conversation.content.messages && conversation.content.messages.length >= 1 && conversation.content.messages[0]
  if (recentMessage) {
    lastUpdatedDate = recentMessage.has_been_deleted
      ? formatLastUpdateDate(conversation.content.messages[0].deletedAt, '', t)
      : formatLastUpdateDate(conversation.content.messages[0].updatedAt, '', t)
    if (recentMessage.has_been_deleted === 1) {
      lastMessage = t('messenger.deletedMessageText')
    } else {
      let lastMessages = recentMessage.message ? recentMessage.message.split('</div><div>') : []
      if (lastMessages.length > 0) {
        lastMessage = lastMessages[0]
      } else if (recentMessage.files && recentMessage.files.length > 0) {
        lastMessage = <Icon name='paperclip' />
      } else {
        lastMessage = ''
      }
    }
  }
  const handleConversationsList = () => {
    closeMenu()
    redirectToPage(`/0/messenger?conversationId=${conversationId}`, true)
  }
  return (
    <button
      // aria-label={t('formlabel.conversationWith', { conv: conversationName })}
      className={styles.conversationsListWrapper}
      onClick={handleConversationsList}>
      <div className={styles.conversationContent}>
        <MemberImages
          imgSizeSingle='xsmall'
          imgSizeDouble='xsmall'
          imgSizeMore='tiny'
          imgSingleCss={styles.oneImageCSS}
          imgDoubleCss={styles.twoImageCSS}
          imgMoreCss={styles.moreImageCSS}
          displayCount={3}
          conversationName={conversationName}
          members={conversation.active_users.filter((u) => !u.is_logged_user)}
        />
        <div className={styles.conversation}>
          <div className={styles.content}>
            <div className={styles.name}>{conversationName}</div>
            {lastUpdatedDate && <span className={styles.date}>{lastUpdatedDate}</span>}
          </div>
          {lastMessage &&
            (typeof lastMessage === 'object' ? (
              <p className={`${styles.lastMessage} ${styles.italicStyle}`}>
                <Icon name='paperclip24' styleModifier={styles.paperClipIcon} />
                {t('global.media')}
              </p>
            ) : (
              <div className={styles.lastMessage} dangerouslySetInnerHTML={{ __html: lastMessage }} />
            ))}
        </div>
        {badge >= 1 && (
          <div className={styles.badge}>
            <Badge size='medium' color='green' text={badge} customCss={styles.customCss} />
          </div>
        )}
      </div>
      <div className={styles.divider} />
    </button>
  )
}

export default ConversationsList
